import { render } from "./VideoContainer.vue?vue&type=template&id=0590bc5e&scoped=true"
import script from "./VideoContainer.vue?vue&type=script&lang=js"
export * from "./VideoContainer.vue?vue&type=script&lang=js"

import "./VideoContainer.vue?vue&type=style&index=0&id=0590bc5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0590bc5e"

export default script